<template>
  <div>
    <modal 
       ref="modal"
      :show-modal="true"
      :closeCallback="closeCallback" >
      <div class="card">
        <div class="card-header">
          <div class="row">
            <h3 class="col mb-0">{{ $t('databasesettings.verificationcode') }}</h3>
          </div>
        </div>
        <div class="card-body">

          <div class="row">
            <div class="col">
              <form-container ref="formContainer_popup" v-bind:model-state="modelState" v-bind:error-message="formError" :enabled="true" :orientation="'horizontal'">
                <div class="detail-item">
                  <div class="col">
                    <p>{{$t('importtask.enterverificationcode')}}</p>
                  </div>
                </div>
                <div class="row container-fluid">
                  <div class="col">
                    <text-input v-bind="formItems.Code" v-model="formItems.Code.value" />
                    <text-input v-bind="formItems.VerificationCode" v-model="formItems.VerificationCode.value" />
                  </div>
                </div>
              </form-container>
            </div>
          </div>
          <div class="row">
            <div class="col text-right">
              <loading-button :title="$t('save')" @click="save" :is-busy="busySaving"></loading-button>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import formmixin from '@/forms/components.js';
import { FormBooleanConfig, FormControl, FormConfig, FormNumericConfig, FormTextConfig } from 'libs/classes/form.js';

import { i18n } from '@/localize';

import ModalComponent from '@/pages/app/MI/components/Modal.vue';

const form = new FormControl();
form.add(new FormTextConfig('Code', i18n.t('databasesettings.code'), null, false, false));
form.add(new FormTextConfig('VerificationCode', i18n.t('databasesettings.verificationcode'), null, true, true));
const config = form.config;

import ImportController from '@/controller/importcontroller.js';
const controller = new ImportController();

export default {
  
  mixins: [formmixin],
  components: {
    'modal': ModalComponent,
  },
  data() {
    return {
      busySaving: false,
      formError: null,
      modelState: null,
      formControl: form,
      formItems: config
    };
  },
  async mounted(){
    let Code = await controller.GetCode();
    this.formControl.loadData({ Code });
  },
  methods: {
    async save () {
      this.formError = null;
      this.modelState = null;
      this.busySaving = true;
      try {
          let result = await controller.SetAdvancedMode(form.getFormData());
          this.$emit('setAdvancedMode');
          if (result) {
            this.manualClose();
          }
      }
      catch (error) {
        if (error.ModelState) {
          this.modelState = error.ModelState;
        } if (error.Error) {
          this.formError = error.Error;
        }
      }
      this.busySaving = false;
      
    },
    closeCallback(){
      this.$emit('close');
    },
    manualClose () {
      this.$refs.modal.manualClose();
      this.closeCallback();
    }
  }
};
</script>